import React from "react";

function VolunteeringCard({ volunteering }) {
  return (
    <div className="card">
      <div>
        <img src={volunteering.logo} alt="" />
      </div>
      <div className="info">
        <div>
          <h4>{volunteering.position}</h4>
          <p>{volunteering.company}</p>
        </div>
        <div>
          <p>{volunteering.location}</p>
          <p>{`${volunteering.date} - ${volunteering.period}`}</p>
        </div>
      </div>
    </div>
  );
}

export default VolunteeringCard;
